import { StrictMode, Suspense, lazy } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/outfit'
import '@fontsource/ibm-plex-mono/400.css'
import './styles.css'
import App from './App'
const PreviewApp = lazy(() => import('./PreviewApp'))
const AdminApp = lazy(() => import('./AdminApp'))

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={null}>{window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/') ? <AdminApp /> : new URLSearchParams(window.location.search).get('spatial-preview') === '1' ? <PreviewApp /> : <App />}</Suspense>
  </StrictMode>,
)

